export const AGENTS_LOCATION_TRACKERS_RESET_STATE= 'AGENTS_LOCATION_TRACKERS_RESET_STATE';
export const AGENTS_LOCATION_TRACKERS_CURRENT_ITEM = 'AGENTS_LOCATION_TRACKERS_CURRENT_ITEM';

export const AGENTS_LOCATION_TRACKERS_REQUEST_LOADING = 'AGENTS_LOCATION_TRACKERS_REQUEST_LOADING';
export const AGENTS_LOCATION_TRACKERS_REQUEST_SUCCESS = 'AGENTS_LOCATION_TRACKERS_REQUEST_SUCCESS';
export const AGENTS_LOCATION_TRACKERS_REQUEST_FAILED = 'AGENTS_LOCATION_TRACKERS_REQUEST_FAILED';

export const AGENTS_LOCATION_TRACKERS_CURRENT_ACTION = 'AGENTS_LOCATION_TRACKERS_CURRENT_ACTION';
export const AGENTS_LOCATION_TRACKERS_RESET_ACTION = 'AGENTS_LOCATION_TRACKERS_RESET_ACTION';